// src/locales/home.js
// English copy for the Lucky Spin Games homepage (site is English-only).

export const COPY = {
  // Nav
  navGames: "Games",
  navAbout: "About",
  navSupport: "Support",
  navContact: "Contact",
  navPlay: "Play Rare Find",

  // Rare Find hero
  rfHeroKicker: "New from LSG",
  rfHeroTitle: "Who sent Iris the sketchbook?",
  rfHeroBody:
    "It landed on her desk in Seattle with a note and a one-way ticket to Vienna. Merge rare finds, follow the clues around the world, and paint every unfinished page back to life.",
  rfTrailer: "Watch the trailer",
  closeTrailer: "Close trailer",

  // Launch state — driven by RF_STORE_STATUS in Home.js.
  // {live}, {soon} and {stores} are filled in with store names automatically.
  // Not live anywhere yet:
  soonTag: "Coming soon",
  soonTitle: "Rare Find is almost here.",
  soonBody:
    "We're putting the last pieces in place. Follow along on Facebook and we'll tell you the moment it's live on {stores}. In the meantime, the playable demo below runs right in your browser.",
  // Live on some stores, coming soon to others:
  partialTag: "Out now on {live}",
  partialTitle: "Rare Find is out now on {live}.",
  partialBody:
    "Coming soon to {soon}. Follow along on Facebook and we'll tell you the moment it arrives.",
  moreStoresSoon: "More stores coming soon",
  // Live everywhere:
  liveTitle: "Rare Find is out now.",
  liveBody: "Choose your store and start the adventure.",
  soonFollow: "Follow on Facebook",
  soonDismiss: "Keep looking around",
  comingSoon: "Coming soon",

  // Sketch-to-color reveal
  revealTitle: "Every page is a real place, waiting for color.",
  revealBody:
    "Keep scrolling and watch it happen. In the game, every merge earns stars, and stars bring each sketch to life.",
  revealHint: "Scroll to restore",

  // Playable demo
  playKicker: "No download needed",
  playTitle: "Try a level right here.",
  playBody:
    "Pick a character below to try their favorite merge mechanic! It's a quick little taste, and it runs right here in your browser!",
  playPickHint: "Choose a character to play",
  playClose: "Close the demo",
  playIris: "Iris' Instinct Adventure",
  playClaire: "Claire's Careful Moves",
  playJake: "Jake's Jungle Moves",

  // Group chat
  chatTitle: "A grand adventure, shared one text at a time.",
  chatBody:
    "Iris traded her desk job for a trail of clues around the world. Back home, Claire and Jake are cheering, worrying, and demanding photos. Every discovery hits the group chat first.",

  // Cast
  castHint: "Tap a character to meet them",
  castIris: "Iris",
  castIrisRole: "The adventurer",
  castIrisQuote: "it's HIS handwriting, Claire. I have to know.",
  castIrisBio:
    "Six years at a Seattle tech job, then a package with no return address. She was somewhere over Greenland before she told anyone she'd left.",
  castClaire: "Claire",
  castClaireRole: "The best friend",
  castClaireQuote: "you don't even know who sent it! do you have a hotel? a plan??",
  castClaireBio:
    "She lost that argument and won the important one: Iris texts every step. Now Claire is three time zones behind, researching castles at midnight, completely invested.",
  castJake: "Jake",
  castJakeRole: "The boyfriend",
  castJakeQuote: "this is the most you thing you've ever done.",
  castJakeBio:
    "He asks for photos of the pastries and keeps telling her to go after the thing she actually wants — he's her biggest fan, three time zones behind.",
  castUnknown: "?",
  castUnknownRole: "Unknown",
  castUnknownQuote: "Reserved under \u201cG.M.\u201d",
  castUnknownBio:
    "No name on the package. No return address. Just notes in handwriting Iris recognizes, always waiting one page ahead of her.",

  // Postcards
  postcardsTitle: "Where the sketchbook leads",
  postcardsBody:
    "Someone stood in each of these places and drew it first. Finish a page, and a clue points to the next.",
  postcardsMore: "Dozens of destinations, with more on the way.",

  // Screenshots
  shotsTitle: "Merge. Find. Discover. Restore. Explore.",

  // MTH
  mthKicker: "Our flagship",
  mthName: "Merge Treasure Hunt",
  mthDesc:
    "The treasure hunt that started it all. Merge real-world antiques, restore stunning scenes, and explore dozens of locations. Loved by players on four platforms.",

  // Stats (MTH)
  statRating: "App Store rating",
  statDownloads: "Downloads on Google Play",
  statRatings: "Player ratings",
  statPlatforms: "Platforms",
  statFootnote: "Merge Treasure Hunt · App Store & Google Play, September 2026",

  // Games
  gamesTitle: "All our games",
  outNow: "Out now",
  liveNow: "Live now",
  inDevelopment: "In development",
  rareName: "Rare Find",
  rareDesc: "Merge rare objects and follow a trail of clues across the world.",
  catsName: "Untitled Merge Project",
  catsDesc: "A brand-new merge world taking shape in the studio. More to reveal soon.",

  // About
  aboutTitle: "Why we made Rare Find",
  aboutBody1:
    "We loved making Merge Treasure Hunt, especially researching the real objects players discover. Rare Find started as an update to it. The team kept bringing new places and new ideas, until it was clear this needed to be its own game, with its own world and its own story.",
  aboutBody2:
    "It's personal, too. Robert grew up on his late grandfather's stories of military service and faraway places. Alex brought his love of philosophy, his time in Cyprus, and years of travel. You'll find a little of both in Iris's journey.",
  aboutBody3:
    "LSG is an American mobile game studio making story-driven merge and puzzle games. We also work with publishers and investors who want polished puzzle games with real staying power.",
  aboutCta: "Email us",

  // Community
  communityTitle: "Join the community",
  rfCommunity: "Rare Find on Facebook",
  rfCommunityBody: "Story updates, new locations, and behind-the-scenes art.",
  mthCommunity: "Merge Treasure Hunt on Facebook",
  mthCommunityBody: "Tips, events, and thousands of fellow treasure hunters.",
  joinFacebook: "Join on Facebook",

  // Support
  supportTitle: "Need help with a game?",
  supportBody:
    "Questions about Merge Treasure Hunt or Rare Find? Our support team will get back to you as soon as possible.",
  supportButton: "Get support",

  // Footer
  footerBlurb: "Lucky Spin Games is a mobile puzzle game studio.",
  footerGames: "Games",
  footerCompany: "Company",
  footerLegal: "Legal",
  footerAbout: "About",
  footerSupport: "Support",
  footerPrivacy: "Privacy Policy",
  footerTerms: "Terms of Use",
  footerCopy: "© {year} Lucky Spin Games. All rights reserved.",
};
